<template>
    <!-- 会员 -->
    <div class="Member_box">
        <div class="hui_box">
            <div class="top_unsName">
                <img class="chanpian_img" src="../../assets/vip.png" alt="">
                <div class="mohuceng"></div>
                <div class="text_name">
                    <div class="yonghu_box">
                        <!-- <img class="Img_touxiang" src="../../assets/IMG-7062.jpg" alt=""> -->
                        <div class="geren_xinxi">
                            <p class="">{{$t("member.huiText2")}}</p>
                            <!-- <p class="">{{$t("member.huiText")}}</p> -->
                        </div>
                    </div>
                    <div class="huiYuan-tilte">
                        {{$t("member.huitilte")}}
                    </div>
                </div>
            </div>
            <div class="huiyuan-div">
                <div :class="Vindex===index?'op_div hongBorder':'op_div'" v-for="(item,index) in viplist" :key="index" @click="huiYuan(item,index)">
                    <p class="zheng_biao">{{item.biaoti}}</p>
                    <div class="H_jiage">
                        <p>￥</p>
                        <p>{{item.money}}</p>
                    </div>
                    <p class="yuanjia_jia">￥{{item.price}}</p>
                    <div class="youhui_css" v-show="index<3">{{item.tehui}}</div>
                    <div class="left_dong" v-show="index<2">{{item.tuijian}}</div>
                </div>

            </div>
            <p class="Tishi_text">{{$t("member.xufei1")}}{{Price}}{{$t("member.xufei2")}}</p>
            <div class="zhifu_box">
                <div class="erweima">
                    <iframe :src="lianjiefukuai" frameborder="0" style=" width: 120px; right: 6px; top: 0; position: absolute; z-index: 0;"></iframe>
                    <div @click="TiaoLoIng()" v-show="this.$store.state.LoginStatus==''" style="width: 100%; height: 100%; background-color:rgba(0,0,0,0.3); 
                        backdrop-filter:blur(7px); z-index: 5; text-align: center; line-height: 120px; cursor: pointer;
                        color: #fff; font-family: Yuanti; font-size: 15px;">
                        您还没有登录
                    </div>
                </div>
                <!-- <img src="../../assets/IMG-7062.jpg" alt=""> -->
                <div class="xinxi_zhifu">
                    <div class="zhifu_jine"><span>￥</span>{{tehuiPrice}} <span></span></div>
                    <div class="zhuyi_fangshi">{{$t("member.way")}}</div>
                    <div class="xufei">
                        {{$t("member.xufei")}}
                        <input style="margin-left: 3px;" type="checkbox">
                    </div>
                </div>
            </div>
            <div class="san_xieyi">
                <router-link to="/songfuwu" class="xieyi_santi_text">{{$t("member.xieyi1")}}</router-link>
                <router-link to="/vipfuwu" class="xieyi_santi_text">{{$t("member.xieyi2")}}</router-link>
                <router-link to="/songxf" class="xieyi_santi_text">{{$t("member.xieyi3")}}</router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name:'Member',
        data(){
            return{
                viplist:[
                    {biaoti:"连续包月",money:3.8,price:"13",tehui:"新用户首月3折",tuijian:"推荐"},
                    {biaoti:"连续包年",money:88,price:"138",tehui:"新用户首年6.4折",tuijian:"多人选择"},
                    {biaoti:"连续包季",money:18,price:"38",tehui:"新用户首季4.7折"},
                    {biaoti:"1个月",money:16,price:"18",tehui:""},
                    {biaoti:"3个月",money:99,price:"172",tehui:""},
                    {biaoti:"12个月",money:158,price:"216",tehui:""}
                ],
                Vindex:0,//vip 选择卡的下表
                Price:13,//价格
                tehuiPrice:3.8,
                lianjiefukuai:'https://wxpay.qifu100.com/pay.html?price=3.8',
            }
        },
        methods:{
            huiYuan(item,index){
                this.Vindex = index;
                this.Price = item.price;
                this.tehuiPrice = item.money;
                this.lianjiefukuai = `https://wxpay.qifu100.com/pay.html?price=${this.tehuiPrice}`;
            },
            TiaoLoIng(){
                this.$router.push('/login')
            }
        }
    }
</script>

<style scoped lang="scss">
    .Member_box{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: 20px;
        .hui_box{
            width: 1100px;
            height: 650px;
            display: flex;
            flex-direction: column;
            align-items: center;
            border:  solid 1px var(--mem-solid);
            box-shadow: 0 5px 10px 0 var(--mem-boxShadow);
            background-color: var(--mem-background-da);
            border-radius: 10px;
            margin-top: 40px;
            overflow: hidden;
            .top_unsName{
                width: 100%;
                height: 150px;
                position: relative;
                background-image: linear-gradient( to left,var(--mem-background));
                overflow: hidden;
                .chanpian_img{
                    position: absolute;
                    width: 300px;
                    height: 300px;
                    right: 100px;
                    top: -55px;
                    transform: rotate(156deg);
                    animation: rotate1 22s infinite linear;
                    z-index: 1;
                }
                .mohuceng{
                    width: 100%;
                    height: 100%;
                    background-color: rgba(0, 0, 0, 0.3);
                    backdrop-filter:blur(18px);
                    position: absolute;
                    z-index: 2;
                }
                .text_name{
                    height: 100%;
                    // background-color: aqua;
                    position: absolute;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    z-index: 3;
                    margin-left: 30px;
                    .yonghu_box{
                        width: 100%;
                        display: flex;  
                        height: 70px;
                        align-items: center;
                        margin-top: 16px;
                        .Img_touxiang{
                            width: 45px;
                            height: 45px;
                            border-radius: 50px;
                            overflow: hidden;
                        }
                        .geren_xinxi{
                            height: 60%;
                            display: flex;
                            flex-direction: column;
                            justify-content: space-around;
                            margin-left: 15px;
                            P:nth-child(1){
                                width: 490px;
                                font-size: 14px;
                                font-family: YuanTi;
                                color: var(--mem-size-name);
                                cursor: pointer;
                            }
                            P:nth-child(2){
                                font-size: 13px;
                                font-family: YuanTi;
                                color: var(--mem-size-tishi);
                            }
                        }
                    }
                    .huiYuan-tilte{
                        width: 80px;
                        height: 45px;
                        line-height: 45px;
                        font-size: 18px;
                        font-family: YuanTi;
                        font-weight: bold;
                        color: var(--mem-zhifu-tilte);
                        text-align: center;
                        margin-left: 50px;
                        cursor: pointer;
                        border-bottom: solid 5px #fff;
                    }
                }
                
                @keyframes rotate1 {
                from {
                    transform: rotate(0deg);
                }
                to {
                    transform: rotate(360deg);
                }
                }
            }
            .huiyuan-div{
                width: 95%;
                // background-color: #222222;
                height: 220px;
                margin-top:20px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .op_div{
                    width: 150px;
                    height: 190px;
                    border-radius: 10px;
                    border: solid 2px var(--mem-ka-solid);
                    box-shadow: 0 4px 10px 0 var(--mem-ka-shadow);
                    background-color: var(--mem-ka-background);
                    cursor: pointer;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    position: relative;

                    .zheng_biao{
                        font-size: 17px;
                        font-family: YuanTi;
                        font-weight: bold;
                        color: var(--ka-size1);
                    }
                    .H_jiage{
                        display: flex;
                        align-items: flex-end;
                        margin-top: 10px;
                        p:nth-child(1){
                            font-size: 15px;
                            color: var(--ka-size2);
                        }
                        p:nth-child(2){
                            font-size:26px;
                            color: var(--ka-size2);
                        }
                    }
                    .yuanjia_jia{
                        font-family: YuanTi;
                        font-size:13px;
                        text-decoration-line: line-through;
                        margin-top: 5px;
                        color: var(--ka-size1);
                    }
                    .youhui_css{
                        width: 100%;
                        height: 32px;
                        position: absolute;
                        bottom: 0;
                        background-color: rgba(255, 0, 0, 0.2);
                        border-bottom-left-radius: 8px;
                        border-bottom-right-radius: 8px;
                        text-align: center;
                        line-height: 32px;
                        font-size: 13px;
                        font-family: YuanTi;
                        color: var(--ka-size3);
                    }
                    .left_dong{
                        padding: 2px 6px;
                        background-image: linear-gradient(to right,rgb(255, 122, 69),rgb(255, 0, 0));
                        color: #fff;
                        font-size: 13px;
                        border-top-right-radius: 8px;
                        border-top-left-radius: 8px;
                        border-bottom-right-radius:8px;
                        position: absolute;
                        top: -10px;
                        left: 0;
                    }
                }
                .hongBorder{
                    border: solid 2px rgb(255, 8, 8);
                    box-shadow: 0 4px 10px 0 var(--mem-ka-shadow);
                    .youhui_css{
                        background-color: rgb(255, 6, 6);
                    }
                }
                .op_div:hover{
                    box-shadow: 0 4px 10px 0 var(--mem-ka-shadow);
                }
            }
            .Tishi_text{
                width: 93%;
                margin-top: 15px;
                font-size: 13px;
                font-family: YuanTi;
                color: var(--ka-size1);
                
            }
            .zhifu_box{
                width: 95%;
                height: 135px;
                // background-color: #2a2a2a;
                display: flex;
                align-items: end;
                margin-top: 20px;
                overflow: hidden;
                .erweima{
                    width: 120px;
                    height: 120px;
                    padding: 3px 3px;
                    background-color: #eeeeee;
                    border-radius: 3px;
                    position: relative;
                    img{
                        width: 110px;
                        height: 110px;
                        object-fit: cover;
                    }
                }
                .xinxi_zhifu{
                    height: 90px;
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-end;
                    margin-left: 20px;
                    .zhifu_jine{
                        width: 100%;
                        font-size: 26px;
                        color: rgb(237, 0, 0);
                        font-family: YuanTi;
                        font-weight: bold;
                        span:nth-child(1){
                            font-size: 15px;
                        }
                        span:nth-child(2){
                            font-size: 17px;
                        }
                    }
                    .zhuyi_fangshi{
                        font-size: 14px;
                        color: var(--ka-size1);
                        font-family: YuanTi;
                        margin-top: 6px;
                    }
                    .xufei{
                        display: flex;
                        align-items: center;
                        font-size: 13px;
                        font-family: YuanTi;
                        margin-top: 8px;
                        cursor: pointer;
                        margin-bottom: 6px;
                        color: var(--xieyi3);
                    }
                }
                
            }
            .san_xieyi{
                    width: 95%;
                    height: 46px;
                    border-top: solid 1px #ececec;
                    margin-top: 23px;
                    display: flex;
                    align-items: center;
                    .xieyi_santi_text{
                        font-size: 12px;
                        font-family: YuanTi;
                        color: var(--xieyi3);
                    }
            }
        }
    }

</style>